/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WeightUnit = exports.VatType = exports.SubscriptionFrequency = exports.MediaItemType = exports.LineItemType = exports.IdentityType = exports.DiscountType = exports.ChannelType = void 0;
var ChannelType;
(function (ChannelType) {
    ChannelType["UNSPECIFIED"] = "UNSPECIFIED";
    ChannelType["WEB"] = "WEB";
    ChannelType["OTHER_PLATFORM"] = "OTHER_PLATFORM";
    ChannelType["WIX_APP_STORE"] = "WIX_APP_STORE";
})(ChannelType = exports.ChannelType || (exports.ChannelType = {}));
var DiscountType;
(function (DiscountType) {
    DiscountType["UNDEFINED"] = "UNDEFINED";
    DiscountType["AMOUNT"] = "AMOUNT";
    DiscountType["PERCENT"] = "PERCENT";
})(DiscountType = exports.DiscountType || (exports.DiscountType = {}));
var IdentityType;
(function (IdentityType) {
    IdentityType["UNSPECIFIED_IDENTITY_TYPE"] = "UNSPECIFIED_IDENTITY_TYPE";
    IdentityType["MEMBER"] = "MEMBER";
    IdentityType["CONTACT"] = "CONTACT";
})(IdentityType = exports.IdentityType || (exports.IdentityType = {}));
var LineItemType;
(function (LineItemType) {
    LineItemType["UNSPECIFIED_LINE_ITEM_TYPE"] = "UNSPECIFIED_LINE_ITEM_TYPE";
    LineItemType["PHYSICAL"] = "PHYSICAL";
    LineItemType["DIGITAL"] = "DIGITAL";
    LineItemType["CUSTOM_AMOUNT_ITEM"] = "CUSTOM_AMOUNT_ITEM";
})(LineItemType = exports.LineItemType || (exports.LineItemType = {}));
var MediaItemType;
(function (MediaItemType) {
    MediaItemType["UNSPECIFIED_MEDIA_TYPE_ITEM"] = "UNSPECIFIED_MEDIA_TYPE_ITEM";
    MediaItemType["IMAGE"] = "IMAGE";
})(MediaItemType = exports.MediaItemType || (exports.MediaItemType = {}));
var SubscriptionFrequency;
(function (SubscriptionFrequency) {
    SubscriptionFrequency["MONTH"] = "MONTH";
    SubscriptionFrequency["WEEK"] = "WEEK";
    SubscriptionFrequency["UNDEFINED"] = "UNDEFINED";
    SubscriptionFrequency["DAY"] = "DAY";
    SubscriptionFrequency["YEAR"] = "YEAR";
})(SubscriptionFrequency = exports.SubscriptionFrequency || (exports.SubscriptionFrequency = {}));
var VatType;
(function (VatType) {
    VatType["UNSPECIFIED_TAX_TYPE"] = "UNSPECIFIED_TAX_TYPE";
    VatType["CPF"] = "CPF";
    VatType["CNPJ"] = "CNPJ";
})(VatType = exports.VatType || (exports.VatType = {}));
var WeightUnit;
(function (WeightUnit) {
    WeightUnit["UNSPECIFIED_WEIGHT_UNIT"] = "UNSPECIFIED_WEIGHT_UNIT";
    WeightUnit["KG"] = "KG";
    WeightUnit["LB"] = "LB";
})(WeightUnit = exports.WeightUnit || (exports.WeightUnit = {}));
//# sourceMappingURL=types.js.map